import React from 'react'

const PauseIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : "24"} height={props.height ? props.height : "24"} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.fill ? props.fill : "#0D1536"} fillOpacity={props.fillOpacity ? props.fillOpacity : ".65"} d="M10 18c0 1.105-.895 2-2 2s-2-.895-2-2V6c0-1.105.895-2 2-2s2 .895 2 2v12zm8 0c0 1.105-.895 2-2 2s-2-.895-2-2V6c0-1.105.895-2 2-2s2 .895 2 2v12z"/>
  </svg>
)

export default PauseIcon
